export default "__VITE_ASSET__DmxyZY_y__"